// @ts-nocheck
import React, {useEffect, useState} from "react";
import "./App.css";
import Header from './layout/Header';
import {HashRouter, Route, Switch} from "react-router-dom";
import DataService from "./DataService";
import Explore from "./pages/Explore";
import MediaContainer from "./pages/MediaContainer";
import LibraryContainer from "./pages/LibraryContainer";
import MSummary from './pages/Summary';
import {ThemeProvider, useTheme} from '@mui/material/styles';
import visuaTheme from './theme';
import Page404 from "./pages/Page404";
import ApplicationLoader from "./components/ApplicationLoader/ApplicationLoader";
import PipelineContainer from "./pages/pipeline-container";
import { LicenseInfo } from '@mui/x-license-pro';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CssBaseline from '@mui/material/CssBaseline';
import {isAdminUser} from "./Helper/UserPermissions";
LicenseInfo.setLicenseKey(
    '97ba783b96ed74ecf1869620362782a8Tz0xMjY5MDgsRT0xODA0OTgyMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
);
function App() {
    const [user, setUser] = useState(null);
    const [fatalError, setFatalError] = useState(false);
    const [fatalErrorMsg, setFatalErrorMsg] = useState(null);

    console.log(user)
    const fetchUser = async (updates = null) => {
        const user = await DataService.getMe();
        user.permission = user.permission || [];
        user.projectTypes = user.projectTypes || [];
        user.subscriptionMeta = user.subscriptionMeta || {};
        user.isAdmin = isAdminUser(user);
        try {
            // isVisualSearch
            user.isVisualSearch = user.projectTypes.some(pt => pt.name === 'visual_search');

            // isVideo
            const responsePars = user.detectionSetting.meta.response_pars
            console.log(responsePars)
            if (typeof responsePars === 'string') {
                user.isVideo = responsePars.includes("video")
            } else if (typeof responsePars.response_type === 'string') {
                user.isVideo = responsePars.response_type.includes("video")
            }

            // isTest
            user.isTest = !!user.developer.developerId
            user.isDetectMultipleScraping = user.permission.some(p => p === 'apiDetectMultipleUrl')
            user.isText = user.projectTypes.some(e => e.name === "text_detection")
        } catch {
            setFatalError(true);
        }

        if (!!updates) {
            user.developer.meta.firehose.apiMonitor.dateRange.begin = updates.begin;
            user.developer.meta.firehose.apiMonitor.dateRange.end = updates.end;
            user.developer.meta.firehose.apiMonitor.minScore = updates.minScore;
        }
        setUser(user);
    };

    // Load user profile
    useEffect(() => {
        fetchUser()
            .catch(err => {
                console.error(err);
                setFatalError(true);
                setUser(null);
            })
    }, []);

    // Check Cookie to warn user when they switch project in another tab
    useEffect(() => {
        function getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        function listenCookieChange(callback, interval = 1000) {
            let lastCookie = getCookie("lastSwitchProject");
            setInterval(() => {
                let cookie = getCookie("lastSwitchProject");
                if (cookie !== lastCookie) {
                    try {
                        callback({oldValue: lastCookie, newValue: cookie});
                    } finally {
                        lastCookie = cookie;
                    }
                }
            }, interval);
        }

        listenCookieChange(_ => {
            setFatalError(true);
            setUser(null);
            setFatalErrorMsg('A change of user or project was detected. Please refresh the page.')
            }, 1000);
    }, [])

    const privateTabs = user?.subscriptionMeta?.metadata?.privateTabs || [];
    const canSeePipeline = !user || isAdminUser(user) || !privateTabs.includes("pipeline");

    return (

        user ? (
            <ThemeProvider theme={visuaTheme}>
                <CssBaseline />
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <HashRouter>
                    <div className="app-layout">
                        <Header user={user}/>
                        <section id="content" className="content">
                            <div
                                className="shuffle-animation"
                            >
                                <Switch>
                                    <Route
                                        exact
                                        path="/"
                                        render={routeProps => (
                                            <MSummary
                                                {...routeProps}
                                                settings={user.developer.meta.firehose.apiMonitor}
                                                isVideo={user.isVideo}
                                                isVisualSearch={user.isVisualSearch}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/media"
                                        render={routerProps => (
                                            <MediaContainer
                                                {...routerProps}
                                                user={user}
                                            />
                                        )
                                        }
                                    />
                                    <Route
                                        path="/library"
                                        render={
                                            routerProps => (
                                                <LibraryContainer
                                                    {...routerProps}
                                                    user={user}
                                                />
                                            )
                                        }
                                    />
                                    <Route
                                        path="/explore"
                                        render={routerProps =>
                                            <Explore
                                                {...routerProps}
                                                user={user}
                                                metaTags={user.subscriptionMeta?.apiExplore?.keys || []}
                                                editors={user.subscriptionMeta?.apiExplore?.developers || []}
                                            />
                                        }
                                    />
                                    {canSeePipeline && (
                                        <Route
                                            path={"/pipeline"}
                                            render={() => <PipelineContainer />}
                                        />
                                    )}
                                    <Route
                                        render={routerProps => (
                                            <Page404/>
                                        )}
                                    />
                                </Switch>
                            </div>
                        </section>
                        <footer
                            style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                paddingLeft: "24px",
                                paddingRight: "24px",
                                paddingTop: "12px",
                                paddingBottom: "12px",
                                backgroundColor: "#f9fafb",
                                borderTopWidth: "1px",
                                borderTopStyle: "solid",
                                borderTopColor: "#e5e7eb",
                                height: "48px"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontSize: "14px",
                                    color: "#4b5563"
                                }}
                            >
                                <span style={{ fontWeight: "500" }}>VISUA API Monitor</span>
                                <span style={{ color: "#9ca3af" }}>•</span>
                                <span>v1.1.0 </span>
                            </div>

                            <div
                                style={{
                                    fontSize: "14px",
                                    color: "#6b7280"
                                }}
                            >
                                © Visua {new Date().getFullYear()}
                            </div>
                        </footer>
                    </div>
                </HashRouter>
            </ThemeProvider>
        ) : (
            <ApplicationLoader
                error={fatalError}
                errorMsg={fatalErrorMsg}
            />
        )
    );
}

export default App;
